import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";

const FloatingButton = () => {
  const location = useLocation();
  const [currentPage, setCurrentPage] = useState("tattoo");

  // Aktualizuj stan przy każdej zmianie lokalizacji
  useEffect(() => {
    if (location.pathname === "/piercing") {
      setCurrentPage("piercing");
    } else if (location.pathname === "/laser") {
      setCurrentPage("laser");
    } else {
      setCurrentPage("tattoo");
    }
  }, [location.pathname]);

  // Funkcja do pobrania opcji, które nie są aktualną stroną
  const getOtherPages = () => {
    const allPages = [
      { name: "Tatuaże", path: "/" },
      { name: "Piercing", path: "/piercing" },
      { name: "Laser", path: "/laser" },
    ];

    return allPages.filter((page) => {
      if (currentPage === "tattoo") return page.path !== "/";
      if (currentPage === "piercing") return page.path !== "/piercing";
      if (currentPage === "laser") return page.path !== "/laser";
      return false;
    });
  };

  const otherPages = getOtherPages();

  return (
    <div className="fixed bottom-8 right-8 z-50">
      <div className="flex flex-col space-y-3">
        {otherPages.map((page, index) => (
          <Link
            key={page.path}
            to={page.path}
            className="block px-6 py-3 bg-black text-white rounded-md font-bold shadow-lg hover:bg-gray-800 hover:shadow-xl transition-all duration-300 transform hover:-translate-y-1 text-center min-w-[120px]"
          >
            {page.name}
          </Link>
        ))}
      </div>
    </div>
  );
};

export default FloatingButton;
